export default __webpack_public_path__ + "static/media/logo.028aa124.png";